var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageDeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.023,
    height: 30.022,
    viewBox: "0 0 30.023 30.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #223c61;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Category",
    "data-name": "Iconly/Bold/Category",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-1",
    d: "M8.887,17.218A3.816,3.816,0,0,1,12.7,21.062h0v5.117a3.825,3.825,0,0,1-3.813,3.843H3.813A3.834,3.834,0,0,1,0,26.179H0V21.062a3.826,3.826,0,0,1,3.813-3.844H8.887Zm17.323,0a3.826,3.826,0,0,1,3.813,3.844h0v5.117a3.834,3.834,0,0,1-3.813,3.843H21.136a3.825,3.825,0,0,1-3.813-3.843h0V21.062a3.816,3.816,0,0,1,3.813-3.844H26.21ZM8.887,0A3.825,3.825,0,0,1,12.7,3.844h0V8.962A3.815,3.815,0,0,1,8.887,12.8H3.813A3.825,3.825,0,0,1,0,8.962H0V3.844A3.835,3.835,0,0,1,3.813,0H8.887ZM26.21,0a3.835,3.835,0,0,1,3.813,3.844h0V8.962A3.825,3.825,0,0,1,26.21,12.8H21.136a3.815,3.815,0,0,1-3.813-3.843h0V3.844A3.825,3.825,0,0,1,21.136,0H26.21Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDeal);
export default __webpack_public_path__ + "static/media/manage_deal.efbd8c3fc2f15c795789b9e23be34be8.svg";
export { ForwardRef as ReactComponent };